<template>
  <div>
    <button @click="active = !active">Göster/Gizle</button>
    <transition name="fade" mode="out-in">
      <div class="box" v-if="active" key="test">Test</div>
      <div class="box2" v-else key="test2">Test2</div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "MultipleElementTransition",
  data() {
    return {
      active: false,
    };
  },
};
</script>

<style scoped>
button {
  margin: 20px 50px;
  background-color: wheat;
  color: green;
  font-size: 14px;
  padding: 15px;
  outline: none;
  border-radius: 5px;
  cursor: pointer;
}
.box {
  width: 200px;
  height: 45px;
  margin-top: 20vh;
  margin-left: 40vw;
  background-color: chartreuse;
  border-radius: 10px;
  padding-top: 20px;
  text-align: center;
}

.box2 {
  width: 200px;
  height: 45px;
  margin-top: 20vh;
  margin-left: 40vw;
  background-color: #64288a;
  border-radius: 10px;
  padding-top: 20px;
  text-align: center;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.5s;
}

.fade-leave {
}

.fade-leave-active {
  transition: opacity 0.5s;
  opacity: 0;
}
</style>